export enum TariffPurchaseSteps {
  List = 0,
  Login = 1,
  Otp = 2,
}
